/**
 * Regular expression to match mentions in a string.
 * Matches user mentions.
 * @type {RegExp}
 */
export const mentionRegex = /[@#][\w]*/g;
